var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.isMobileHomeVisible)?_c('mobile-home'):_c('full-home')}
var staticRenderFns = []

export { render, staticRenderFns }